import {ApiClient} from '@hconnect/apiclient'

import {MaterialStoragesHistory} from '../types'

export const MaterialStorageHistoryQueryKey = 'material-storage-history'

export const materialStorageHistoryQueryOptions = (plantId: string, from: string, to: string) => ({
  queryKey: [MaterialStorageHistoryQueryKey, plantId, from, to] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<MaterialStoragesHistory>(
      `/plants/${plantId}/material-storage/history`,
      {params: {from, to}, signal}
    )
    return response.data
  }
})
